import Cookies from 'js-cookie';

import { isDevEnvironmentSwitcherEnabled } from './environments';

const COOKIE_KEY = 'DEV_SHOW_DISCARDED_LISTS';
const cookieOptions = { path: '/' };

export const SHOW_DISCARDED_LISTS_COOKIE_KEY = COOKIE_KEY;

export const isDiscardedListsEnabled = () =>
    isDevEnvironmentSwitcherEnabled() && Cookies.get(COOKIE_KEY) === '1';

export const setDiscardedListsEnabled = (enabled) => {
    if (!isDevEnvironmentSwitcherEnabled()) return;

    if (enabled) {
        Cookies.set(COOKIE_KEY, '1', cookieOptions);
        return;
    }

    Cookies.remove(COOKIE_KEY, cookieOptions);
};
